export default "__VITE_ASSET__d04931ef__"